import React, { useState } from 'react';
import {useLocation, useNavigate} from "react-router-dom";

import Agent from "../../Network/Agent";
import ToolBar from "../../Components/Elements/ToolBar";
import InputPrimary from "../../Components/Elements/InputPrimary";
import ButtonPrimary from "../../Components/Elements/ButtonPrimary";
import {RouteEnumFinal} from "../../Config/RouteEnum";
import ButtonSecondary from "../../Components/Elements/ButtonSecondary";
import {getRedirectUrl} from "../../Components/Utils/getRedirectUrl";

const Verify = () => {
    const [code, setCode] = useState('')
    const [buttonLoading, setButtonLoading] = useState(false);
    const [errors, setErrors] = useState({ otp: null });

    const navigate = useNavigate()

    const {state} = useLocation()
    const {phoneNumber, passport} = state

    const submitCode = async (e) => {
        e.preventDefault();
        setButtonLoading(true);

        if (code.length < 4) {
            setErrors({ otp: 'کد وارد شده باید حداقل 4 کارکتر باشد' });
            setButtonLoading(false);
        } else {
            try {
                const response = await Agent.Auth.verify(code, passport);
                const {authorizationToken : token, stores} = response.data.result;
                Agent.setAuthToken(token)
                sessionStorage.clear();
                if(stores.length) {
                    const firstStore = stores.at(0)
                    window.location.href = getRedirectUrl(firstStore.username, token)
                } else {
                    navigate(RouteEnumFinal.AUTH_CREATE_STORE)
                }
            } catch (error) {
                setErrors({ otp: error.response.data.errors.at(0).message });
                setButtonLoading(false);
            }
        }
    };

    return (
        <>
            <ToolBar title={'کد فعال سازی'} url={""} arrowDisplay={"d-none"} />
            <section className=''>
                <div className='container'>
                    <div className='row'>
                        <div className='col-12'>
                            <div className='mobile-subtitle-regular cl-subtitle mt-8'>
                                کد ارسال شده به شماره {phoneNumber} را وارد کنید :
                            </div>
                        </div>
                        <div className='col-12'>
                            <form id='form_send_code' onSubmit={submitCode}>
                                <div className='mt-32'>
                                    <InputPrimary
                                        dir='ltr'
                                        inputClasses={errors.otp === null ? 'text-center' : 'text-center hasError'}
                                        name='user_code'
                                        id='user_code'
                                        type='number'
                                        value={code}
                                        onChange={(e) => setCode(e.target.value)}
                                        placeHolder='* * * *'/>
                                    <div className='mobile-body-1-regular cl-tomato mt-custom-4 mr-8'>
                                        {errors.otp || ''}
                                    </div>
                                </div>
                                <div className='mt-32'>
                                    <ButtonPrimary
                                        mode='dark-mode'
                                        text='تایید'
                                        isLoading={buttonLoading}
                                    />
                                </div>
                            </form>
                            <div className='mt-32'>
                                <ButtonSecondary
                                    mode='dark-mode'
                                    className="border-0 td-none"
                                    href={RouteEnumFinal.AUTH_LOGIN_PHONE}
                                    isLoading={false}
                                    isDisabled={false}>
                                    <div className="d-flex align-items-center gap-2">
                                        ویرایش شماره
                                    </div>
                                </ButtonSecondary>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Verify;
